import rp from "@reporting/rp-app-host";
import { Resource } from "@reporting/rp-types/ext";
import { SheetEditorAdapter } from "../components/sheetEditor";

export class ExtensionSheetEditorAdapter extends SheetEditorAdapter {

	private _resource: Resource;

	constructor(readonly id: number) { super() }

	async getResource() : Promise<Resource> {
		if (this._resource) return this._resource;
		this._resource = this.id ? await rp.ms('extensions').get<Resource>(`resources/${this.id}`) : {};
		return this._resource;
	}

	async getContent() : Promise<string> {
		return await rp.ms('extensions').get<string>(`resourceContent/${this.id}`, null, {
			parseResponse: false
		});
	}

	async save(content: string): Promise<boolean> {
		await rp.ms('extensions').post(`resourceContent/${this.id}`, content);
		return true;
	}

}
